const periodicity = {
  none: I18n.t(`web.memberships.periodicity.none`),
  week: I18n.t(`web.memberships.periodicity.week`),
  fifteen_days: I18n.t(`web.memberships.periodicity.fifteen_days`),
  month: I18n.t(`web.memberships.periodicity.month`),
  two_months: I18n.t(`web.memberships.periodicity.two_months`),
  three_months: I18n.t(`web.memberships.periodicity.three_months`),
  six_months: I18n.t(`web.memberships.periodicity.six_months`),
  year: I18n.t(`web.memberships.periodicity.year`),
  two_years: I18n.t(`web.memberships.periodicity.two_years`),
  three_years: I18n.t(`web.memberships.periodicity.three_years`),
  four_years: I18n.t(`web.memberships.periodicity.four_years`),
  five_years: I18n.t(`web.memberships.periodicity.five_years`),
};

const paymentMethods = {
  cash: I18n.t(`views.backoffice.search_form.membership.method.cash`),
  card: I18n.t(`views.backoffice.search_form.membership.method.card`),
  check: I18n.t(`views.backoffice.search_form.membership.method.check`),
  direct_debit: I18n.t(
    `views.backoffice.search_form.membership.method.direct_debit`,
  ),
  bank_transfer: I18n.t(
    `views.backoffice.search_form.membership.method.bank_transfer`,
  ),
  external_institution: I18n.t(
    `views.backoffice.search_form.membership.method.external_institution`,
  ),
  sepa_debit: I18n.t(
    `views.backoffice.search_form.membership.method.sepa_debit`,
  ),
};

export const translations = {
  periodicity,
  paymentMethods,
};
